import { ReactElement } from 'react';

import { RdPathLoader, PayrollQreLayout } from '@neo.tax/rd/organisms';
import { Path } from '@neo.tax/shared';

import { usePayrollQresRedirect } from './hooks';

export const PayrollQres = (): ReactElement => (
  <RdPathLoader path={Path.PAYROLL_QRE} useRedirect={usePayrollQresRedirect}>
    <PayrollQreLayout />
  </RdPathLoader>
);
